import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { wishlistAPI } from '../services/api';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWishlist = useCallback(async () => {
    if (!user) return;
    try {
      setLoading(true);
      const { data } = await wishlistAPI.get();
      setWishlist(data.wishlist);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { fetchWishlist(); }, [fetchWishlist]);

  const toggleWishlist = useCallback(async (productId) => {
    if (!user) { toast.error('Please login to add to wishlist'); return; }
    try {
      const { data } = await wishlistAPI.toggle(productId);
      toast.success(data.message);
      await fetchWishlist();
      return data.action;
    } catch (e) { toast.error('Failed to update wishlist'); }
  }, [user, fetchWishlist]);

  const isInWishlist = useCallback((productId) => {
    return wishlist.some(w => w.product?._id === productId || w.product === productId);
  }, [wishlist]);

  return (
    <WishlistContext.Provider value={{ wishlist, loading, toggleWishlist, isInWishlist, fetchWishlist, count: wishlist.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be inside WishlistProvider');
  return ctx;
};
